/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Maple_Wasp_GrowInputs */

const en_warm_maple_wasp_grow = /** @type {(inputs: Warm_Maple_Wasp_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search...`)
};

const de_warm_maple_wasp_grow = /** @type {(inputs: Warm_Maple_Wasp_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche...`)
};

/**
* | output |
* | --- |
* | "Search..." |
*
* @param {Warm_Maple_Wasp_GrowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_maple_wasp_grow = /** @type {((inputs?: Warm_Maple_Wasp_GrowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Maple_Wasp_GrowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_maple_wasp_grow(inputs)
	return de_warm_maple_wasp_grow(inputs)
});